import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const SESSION_KEY = 'sonrisa-clara-loaded';
const VISIBLE_MS = 3500;
const TOOTH_PATH = 'M8.5 3.6C6.6 3.6 5 5.1 5 7.3c0 2.1.6 3.3 1 5.3.4 2 .5 5 1.9 5 1.3 0 1.4-3.2 2.6-3.2h1c1.2 0 1.3 3.2 2.6 3.2 1.4 0 1.5-3 1.9-5 .4-2 1-3.2 1-5.3 0-2.2-1.6-3.7-3.5-3.7-1.2 0-2 .6-3 .6s-1.8-.6-3-.6z';

/**
 * Pantalla de carga inicial: el diente se dibuja solo (2s), se rellena en aqua (0.8s),
 * aparecen logo y subtexto, y la barra de progreso acompaña los 3.5s totales.
 * Solo se muestra en la primera carga de la sesión.
 */
export function LoadingScreen() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem(SESSION_KEY) !== 'true';
  });
  useEffect(() => {
    if (!visible) return;
    document.body.style.overflow = 'hidden';
    const timer = window.setTimeout(() => {
      window.sessionStorage.setItem(SESSION_KEY, 'true');
      setVisible(false);
    }, VISIBLE_MS);
    return () => {
      window.clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, [visible]);
  return <AnimatePresence data-id="element-152" data-mp="2m7hkvk7s2eat">
      {visible && <motion.div key="loading" initial={{
      opacity: 1
    }} exit={{
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }} className="fixed inset-0 z-[9999] flex h-screen w-screen flex-col items-center justify-center bg-primary" role="status" aria-live="polite" aria-label="Cargando Sonrisa Clara" data-id="element-153" data-mp="27hjz1axbm0os">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" className="h-20 w-20" data-id="element-154" data-mp="1oipneat5lgcu">
            <path d={TOOTH_PATH} className="sc-tooth-fill" fill="#3AAFA9" data-id="element-155" data-mp="1ti29gtc7ajed" />
            <path d={TOOTH_PATH} className="sc-tooth-draw" stroke="#FFFFFF" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" data-id="element-156" data-mp="3iw74bez1zeyw" />
          </svg>

          <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1,
        transition: {
          delay: 2,
          duration: 0.4,
          ease: 'easeOut'
        }
      }} className="mt-6 font-display text-[28px] font-bold text-white" data-id="element-157" data-mp="3mf665r44cf6z">
            Sonrisa Clara
          </motion.p>
          <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1,
        transition: {
          delay: 2.2,
          duration: 0.4,
          ease: 'easeOut'
        }
      }} className="mt-2 font-sans text-[14px] text-white/60" data-id="element-158" data-mp="37i5cvj6a4c6e">
            Odontología moderna
          </motion.p>

          <span className="mt-6 block h-[3px] w-[120px] overflow-hidden rounded-pill bg-white/15" data-id="element-159" data-mp="3vdhvzqx5v8yd">
            <span className="sc-progress-fill block h-full w-full rounded-pill bg-secondary" data-id="element-160" data-mp="3qef292mmsp5p" />
          </span>
        </motion.div>}
    </AnimatePresence>;
}